
const SettingsContainer = {
  data:[],

  setSettings: function (data) {
    SettingsContainer.data=data;
  },
  getSettings: function () {
    return SettingsContainer.data;
  },


};

export default SettingsContainer;
